<template>
    <div>
    <footer id="footer" class="footer">
        <div class="footer-info text-center row">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="footer-info-content">
                            <div class="footer-logo">
                                <img class="img-fluid" src="/images/szflogo_footer.png" alt="">
                            </div>
                            <p>A madár sem szállhat, ha szárnyát szegik. A székely sem élhet örök rabságban.</p>
                            <p class="footer-info-email"><i class="fa fa-envelope-o"></i> kapcsolat@szekelyfold.ma</p>
                            <p>
                                <img src="/images/BGA-logo-1.jpg" border="0" class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mt-3"/>
                            </p>
                            <ul class="unstyled footer-social">
                                <li>
                                    <a title="Rss" href="#" class="d-none">
                                        <span class="social-icon"><i class="fas fa-rss"></i></span>
                                    </a>
                                    <a title="Facebook" href="https://www.facebook.com/Szekelyfold.ma">
                                        <span class="d-inline-block social-icon"><i class="fab fa-facebook"></i></span>
                                        <span class="d-inline-block">Facebook</span>
                                    </a>
                                    <a title="Twitter" href="#" class="d-none">
                                        <span class="social-icon"><i class="fab fa-twitter"></i></span>
                                    </a>
                                    <a title="Instagram" href="#" class="d-none">
                                        <span class="social-icon"><i class="fab fa-instagram"></i></span>
                                    </a>
                                </li>
                            </ul>
                        </div><!-- Footer info content end -->
                    </div><!-- Col end -->
                </div><!-- Row end -->
            </div><!-- Container end -->
        </div><!-- Footer info end -->
        <cookie-law theme="blood-orange">
            <div slot-scope="props" class="row w-100">
                <div class="col-lg-12 col-sm-12 col-xs-12 col-md-12 mpad">
                    <div class="row">
                        <div class="col-lg-10 col-xs-6 col-sm-6 col-md-10">
                            <p class="pt-3 fs-10">
                                E honlap felhasználói élmény fokozásának érdekében sütiket (cookies) alkalmazunk.
                                <a href="/sutik" target="_blank">További infók</a>
                                <button class="ml-2 btn-sm btn-warning d-lg-none d-sm-block fs-10 mb-1" @click="props.accept"><span>Beleegyezek</span></button>
                            </p>
                        </div>
                        <div class="col-lg-2 mt-2 col-xs-6 col-sm-6 col-md-2">
                            <button class="btn btn-warning" @click="props.accept"><span>Beleegyezek</span></button>
                        </div>
                    </div>
                </div>
            </div>
        </cookie-law>
    </footer>
        <Copyright></Copyright>
</div>
</template>

<script>
    import CookieLaw from 'vue-cookie-law'
    import Copyright from "./Copyright";
    export default {
        name: 'Footer',
        components: {
            Copyright,
            CookieLaw
        }
    }
</script>

<style lang="scss">
    @import '~@/absctracts/variables.scss';

    .footer {
        background-color: #1c1c1c;
        color: #969696;
        padding: 70px 0;

        @media (min-width: 992px) {
            .footer-info-content {
                padding: 20px 250px 14px;
            }
        }

        .footer-info-content {
            border-top: 1px solid #606060;

            .footer-logo img {
                display: inline-block;
                margin-bottom: 10px;
                height: 65px;
            }

            .bga-logo {
                width: 340px;
                height: 75px;
            }

            p {
                background-color: transparent;
                color: #969696;
                font-size: 13px;
                margin-bottom: 2px;
            }

            .footer-info-phone, .footer-info-email {
                display: inline-block;
                margin: 0 5px;
            }

            .footer-social {
                list-style: none;
                margin: 15px 0 0 0;
                padding: 0;

                li {
                    margin: 0;

                    a {
                        color: #a3a3a3;
                        display: inline-block;
                        margin: 0 3px;

                        .social-icon {
                            list-style: none;
                            margin: 0;
                            padding: 0;

                            i {
                                display: block;
                                width: 32px;
                                height: 32px;
                                line-height: 32px;
                                font-size: 12px;
                                color: #fff;
                                background: #282828;
                                text-align: center;
                                -webkit-transition: 400ms;
                                -moz-transition: 400ms;
                                -o-transition: 400ms;
                                transition: 400ms;
                            }

                            i:hover {
                                color: $red;
                            }
                        }
                    }
                }
            }
        }
    }

    .Cookie--blood-orange {
        background: #222;
        color: #fff;
        font-size: 17px;
        font-family: "Helvetica Neue Light", "HelveticaNeue-Light", "Helvetica Neue", Calibri, Helvetica, Arial;
        box-sizing: border-box;
        height: 55px;

        p {
            background-color: transparent;
            color: white;
        }
    }

    .fs-10 {
        font-size: 20px;
    }

    @media (max-width: 576px) {
        .mpad {
            position: relative;
            top: -49px;
            font-size: 12px;
        }

        .fs-10 {
            font-size: 10px;
        }
    }

</style>
